import { SET_ABOUT, CLEAR_ABOUT } from "../actions/aboutActions";

const initialState = {
  about: {}
}

function aboutReducer(state = initialState, action) {
  switch (action.type) {
  case SET_ABOUT:
    return {
      ...state,
      about: action.payload
    }
  case CLEAR_ABOUT:
    return {
      ...state,
      about: {}
    }
  default:
    return state;
  }
}

export default aboutReducer;